import axios from "axios";
import { log } from "common/Logger";
import { FileStatusResponse, ProjektDokument } from "domain/Types";

const fileStatusApi = axios.create({
  baseURL: process.env.REACT_APP_FILE_STATUS_URL?.split("?")[0],
});

export const getFileStatus = async (sessionId: string, fileId: string): Promise<FileStatusResponse> => {
  log.debug("will get file status");
  const response = await fileStatusApi.get<FileStatusResponse>(`?${process.env.REACT_APP_FILE_STATUS_URL?.split("?")[1]}&sessionId=${sessionId}&fileId=${fileId}`);
  log.trace({ obj: response.data }, "result from get file status");
  return { ...response.data, fileId };
};

export const checkAllFileStatus = async (sessionId: string, files: ProjektDokument[]) => {
  const fileChecks = files.map((file) => {
    return getFileStatus(sessionId, file.fileId);
  });
  return Promise.allSettled(fileChecks);
};
